/**
 * Config for the AI clients shown in the MCP Personal setup docs.
 *
 * The human-readable copy (name, kind, add-step title, add-step note) lives in
 * i18n under `automations.cards.mcp_personal.setup.clients.<id>`.
 */
export type McpClientId = 'claude_desktop' | 'chatgpt';

export interface McpClient {
  id: McpClientId;
}

export const MCP_CLIENTS: McpClient[] = [
  { id: 'claude_desktop' },
  { id: 'chatgpt' },
];
